export default {"src":"/_next/static/media/SHAK.bc372bae.svg","height":18,"width":18};